<script>
import { Line } from "vue-chartjs"

export default {
  extends: Line,
  methods: {
    calculatedColors() {
      if (this.$store.state.site.whitelabel) {
        return {
          borderColorUsers: "#0179F3",
          borderColorUploads: "#0190EA"
        }
      } else {
        return {
          borderColorUsers: "#0179F3",
          borderColorUploads: "#0190EA"
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.axios.get("/api/v1/site/state/stats").then((res) => {
        this.$store.commit("stateStats", res.data)
        this.$store.commit("setRoute", this.$route.name)
        this.renderChart(
          {
            labels: this.$store.state.site.stats.uploadGraph.labels,
            datasets: [
              {
                label: "Uploads",
                data: this.$store.state.site.stats.uploadGraph.data,
                backgroundColor: "transparent",
                borderColor: this.calculatedColors().borderColorUploads,
                pointBackgroundColor: "#FFFFFF"
              }
            ]
          },
          {
            responsive: true,
            maintainAspectRatio: false,
            title: {
              display: false
            }
          }
        )
      })
    })
  }
}
</script>
